import React from 'react';
import { Route, Switch, RouteComponentProps, Redirect } from 'react-router-dom';
import styled, { css, keyframes } from 'styled-components';
import Navigation from '../../containers/header';

import ResultContainer from '../../containers/search/tabResult';
import AIRecommendContainer from '../../containers/search/tabAIRecommend';
import ImageContainer from '../../containers/search/tabImage';
import SimilarImageContainer from '../../containers/search/tabSimilarImage';

import Footer from './footer';

import { searchKeywordState } from '../../modules/searchKeyword';

const SearchComponent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

interface SearchType extends RouteComponentProps {
  onSetSearchKeyword: (
    searchKeyword: searchKeywordState['searchKeyword']
  ) => void;
}

class Search extends React.PureComponent<SearchType> {
  render() {
    const { match } = this.props;
    return (
      <SearchComponent>
        <Navigation />

        <Switch>
          <Route
            exact
            path={`${match.url}/result`}
            component={ResultContainer}
          />
          <Route
            exact
            path={`${match.url}/ai`}
            component={AIRecommendContainer}
          />
          <Route exact path={`${match.url}/image`} component={ImageContainer} />
          <Route
            exact
            path={`${match.url}/similarImage`}
            component={SimilarImageContainer}
          />

          <Redirect path="*" to="/" />
        </Switch>

        <Footer />
      </SearchComponent>
    );
  }
}

export default Search;
